import { Directive, ElementRef, TemplateRef } from '@angular/core';

import { PopupComponent } from '../components/popup.component';

@Directive({
  selector: 'appPopupTemplate, [appPopupTemplate]',
  standalone: false,
})
export class PopupDirective {
  constructor(
    private cmPopupComponent: PopupComponent,
    public elementRef: ElementRef,
    private templateRef: TemplateRef<any>
  ) {
    this.cmPopupComponent.customPopupTemplate = this.templateRef;
  }
}
